module.exports = __webpack_public_path__ + "static/media/avatar.1afc53d5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/avatar.svg
// module id = 1266
// module chunks = 0